module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hSKqg"))).then(() => module.bundle.root('gtEzC'));